import React from "react";
import { EventInventoryRecord } from "@src/store/pricing/queryEventInventoryAllSlice";
import { useAppSelector } from "@src/store/hooks";
import { X } from "lucide-react";
import styles from "./BulkHoldListings.module.scss";
import helperStyles from "@src/components/helpers.module.scss";
import { clx } from "../utils/stringUtils";
import { formatCurrency } from "../utils/numberUtils";

type TBulkHoldListingsItem = {
	data: EventInventoryRecord;
	appliedDurationLabel: string;
	onRemove?: (listingId: number) => void;
};

const BulkHoldListingsItem = ({ data, appliedDurationLabel, onRemove }: TBulkHoldListingsItem) => {
	const selectionEvent = useAppSelector((state) => state.pricing.selection.event);

	const itemAny = data as EventInventoryRecord & { Event_Headliner?: string; Event_Name?: string };
	const eventName = itemAny.Event_Headliner ?? itemAny.Event_Name ?? selectionEvent?.Event_Headliner ?? "";

	const quantity = data.Quantity || 1;
	const perTicketPrice = data.Item_Price ?? 0;

	const existingComments = data.On_Hold ? (data.On_Hold_Comments ?? "").trim() : "";

	return (
		<div className={styles.singleListing}>
			<div className={styles.secRowSeat}>
				<div className={styles.secRowSeatCont}>
					<div style={{ userSelect: "none" }} className={clx(styles.itemTextPrimary, helperStyles.ellipsisDiv)}>
						{eventName}
					</div>
					<div className={styles.itemTextPrimary}>
						{data.Section}, Row {data.Row}
					</div>
					<div style={{ gap: "2px 8px" }} className={clx(styles.textSecondary, helperStyles.flexSmallGap)}>
						<div>ID: {data.Listing_ID}</div>
						<div>Seat {data.Seats}</div>
					</div>
				</div>
			</div>
			<div className={clx(styles.duration, helperStyles.ellipsisDiv)}>{appliedDurationLabel || "—"}</div>
			<div className={styles.existingComments}>{existingComments || "—"}</div>
			<div className={clx(styles.qty, helperStyles.ellipsisDiv)}>{quantity}</div>
			<div className={clx(styles.priceLabel, helperStyles.ellipsisDiv)}>{formatCurrency(perTicketPrice)}</div>
			<div onClick={() => onRemove?.(data.Listing_ID)} className={styles.xContainer}>
				<div>
					<X size={16} />
				</div>
			</div>
		</div>
	);
};

export default BulkHoldListingsItem;
